import React, { useState, useEffect } from "react";
import "./Navbar.css";

export default function Navbar({ activePage, navigate, showComingSoon }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isDark = activePage === "home";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu whenever page changes
  useEffect(() => {
    setMenuOpen(false);
  }, [activePage]);

  // Reset scrolled state when leaving home (light pages are always opaque)
  useEffect(() => {
    if (!isDark) setScrolled(false);
  }, [isDark]);

  const navClass = [
    "nav",
    isDark && scrolled ? "scrolled" : "",
    !isDark ? "light-page" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const handleNav = (page) => {
    navigate(page);
    setMenuOpen(false);
  };

  return (
    <>
      <nav className={navClass}>
        <div className="nav-inner">
          {/* Logo */}
          <button className="nav-logo" onClick={() => handleNav("home")}>
            <div className={`logo-mark ${!isDark ? "dark" : ""}`}>RD</div>
            <div className={`logo-text ${!isDark ? "dark" : ""}`}>
              RoadDogg<span> AI</span>
            </div>
          </button>

          {/* Desktop links */}
          <ul className={`nav-links ${!isDark ? "dark" : ""}`}>
            <li>
              <a onClick={() => handleNav("home")}>Home</a>
            </li>
            <li>
              <a onClick={() => handleNav("about")}>About</a>
            </li>
            <li>
              <a onClick={() => handleNav("privacy")}>Privacy</a>
            </li>
            <li>
              <a onClick={() => handleNav("terms")}>Terms</a>
            </li>
            <li>
              <a onClick={() => handleNav("support")}>Support</a>
            </li>
            <li>
              <a
                className={`nav-cta ${!isDark ? "dark-cta" : ""}`}
                onClick={showComingSoon}
                href="#"
                style={{ cursor: "pointer" }}
              >
                Download App
              </a>
            </li>
          </ul>

          {/* Hamburger */}
          <button
            className={`hamburger ${!isDark ? "dark" : ""} ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className={`mobile-menu ${!isDark ? "light" : ""}`}>
          <a onClick={() => handleNav("home")}>Home</a>
          <a onClick={() => handleNav("about")}>About</a>
          <a onClick={() => handleNav("privacy")}>Privacy Policy</a>
          <a onClick={() => handleNav("terms")}>Terms & Conditions</a>
          <a onClick={() => handleNav("support")}>Support</a>
          <a className="mob-cta" onClick={showComingSoon} href="#">
            Download App
          </a>
        </div>
      )}
    </>
  );
}
